import * as React from "react";
const Arrow = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}><path d="M30 34.08 9.77 13.68a5.71 5.71 0 0 0-8.09 0 5.8 5.8 0 0 0 0 8.16L26 46.31a5.7 5.7 0 0 0 8.1 0l24.22-24.46a5.81 5.81 0 0 0 0-8.16 5.72 5.72 0 0 0-8.09 0Z" /></svg>;
export default Arrow;